import { useEffect, useState } from 'react'
import '../stile-avvisi.css'
import { useSessione } from '../servizi/sessione.tsx'
import {
  chiediPermesso, leggiPreferenze, notificheComputerPossibili, salvaPreferenze, seguiPreferenze, statoPermesso,
} from '../servizi/avvisi.ts'
import { Bottone, Etichetta, Riquadro, Spunta } from './base.tsx'
import { Avviso } from './Pezzi.tsx'

/**
 * Avvisi su questo computer (2/11/2026), nella pagina Notifiche: i riquadri in basso a destra e le
 * notifiche del sistema, con lo stato del permesso del browser. Le scelte valgono per questo computer e
 * per questa persona (servizi/avvisi.ts, localStorage); il permesso si chiede solo dal bottone.
 */
export function PreferenzeAvvisi() {
  const { io } = useSessione()
  const [, ridisegna] = useState(0)
  useEffect(() => seguiPreferenze(() => ridisegna((n) => n + 1)), [])
  if (!io || io.impersonazione) return null

  const p = leggiPreferenze(io.id)
  const possibili = notificheComputerPossibili()
  const permesso = statoPermesso()
  const cambia = (parte: Partial<typeof p>) => salvaPreferenze(io.id, { ...p, ...parte })

  return (
    <div id="avvisi-computer">
      <Riquadro titolo="Avvisi su questo computer">
        <div className="avvisi-preferenze">
          <Spunta etichetta="Avvisi sullo schermo" valore={p.schermo} cambia={(v) => cambia({ schermo: v })}
                  aiuto="Con il gestionale aperto, un riquadro in basso a destra per ogni email o notifica nuova: di
                    un’email dice mittente e oggetto. Si chiude da solo dopo otto secondi; un clic apre l’email o
                    la notifica." />
          {possibili && (
            <Spunta etichetta="Notifiche del computer" valore={p.sistema && permesso !== 'denied'}
                    disabilitato={permesso === 'denied'}
                    cambia={(v) => cambia({ sistema: v })}
                    aiuto="Con il gestionale in secondo piano, una notifica del computer: «Nuova email in» e la
                      casella, oppure «Nuovo avviso nel gestionale». Niente mittente né contenuto, perché resta nel
                      centro notifiche del computer. Arrivano finché la sessione resta aperta: dopo un’ora senza
                      usare il gestionale la sessione si chiude e smettono." />
          )}
        </div>
        {possibili && p.sistema && (
          <div className="avvisi-permesso">
            {permesso === 'granted' && <Etichetta tono="positivo">consentite dal browser</Etichetta>}
            {permesso === 'default' && (
              <Bottone variante="secondario" dimensione="piccolo" onClick={() => void chiediPermesso()}>
                Attiva le notifiche del computer
              </Bottone>
            )}
          </div>
        )}
        {possibili && permesso === 'denied' && (
          <Avviso tipo="attenzione">
            Le notifiche del computer sono bloccate nel browser. Per riattivarle apri le impostazioni del sito (il
            lucchetto accanto all’indirizzo), consenti le notifiche e ricarica la pagina.
          </Avviso>
        )}
        {!possibili && (
          <p className="piccolo tenue">
            Su questo dispositivo ci sono solo i riquadri. Sul telefono gli avvisi arrivano con l’app CIDIS; le
            notifiche del computer si attivano dal browser di un computer.
          </p>
        )}
        <p className="piccolo tenue">Le scelte valgono per questo computer e per il tuo accesso.</p>
      </Riquadro>
    </div>
  )
}
